import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ImportOption} from '../model/importOptionEnum';
import {DuplicateOptionEnum} from '../model/duplicateOptionEnum';
import {ProjectLevel} from '../model/projectLevelEnum';


@Component({
  selector:'import-duplicate-modal',
  template:`
    <div [style.display]="!hide ? 'inline' : 'none'" class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
              <img class="cloneWindow" src="../../assets/images/clone.png" alt="warning">
            <h4 class="modal-title">Import & Copy Options</h4>
              <h4 class="closeBtnH4"><button (click)="toggle();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                  <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
              </button></h4>
          </div>
            <div class="modalBodyContainer">
          <div class="modal-body">
            <form action="#">
              <p *ngIf="forCopyIntention">
                <input type="radio" id="test5" name="radio-group" value="fullCopy" (click)="select($event)">
                  <label for="test5">Full Copy <span style="margin-left:5px;color:#00b0ff"><i class="fa fa-info" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="Copy everything including assets.This includes questionnaires and terminals."></i></span></label>
              </p>
              <p *ngIf="forCopyIntention">
                <input type="radio" id="test6" name="radio-group" checked value="configOnly" (click)="select($event)">
                <label for="test6">Configuration Only <span style="margin-left:5px;color:#00b0ff"><i class="fa fa-info" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="Copy everything without assets.This includes questionnaires and terminals"></i></span></label>
              </p>
              <p *ngIf="!forCopyIntention && level!==3" >
                <input type="radio" id="test1" name="radio-group" value="full" (click)="select($event)">
                <label for="test1">Fully Import the {{getCorrespondingHierarchy()}}<span style="margin-left:5px;color:#00b0ff"><i class="fa fa-info" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="This option provides a full copy of the intended entity."></i></span></label>
              </p>
              <p *ngIf="level === 3">
                <input type="radio" id="test2" name="radio-group"  value="full" (click)="select($event)">
                <label for="test2">Import all files in the directory</label>
              </p>
              <p *ngIf="!forCopyIntention">
                <input type="radio" id="test2" name="radio-group" checked value="only" (click)="select($event)">
                <label for="test2">{{getCorrespondingHierarchy()}} Only<span style="margin-left:5px;color:#00b0ff"><i class="fa fa-info" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="This option only copies the intended entity at a very basic level.(Does not include post-sync actions,assets or any other specs.)"></i></span></label>
              </p>
              <p *ngIf="level === 2 ">
                <input type="radio" id="test3" name="radio-group" value="terminalAssets" (click)="select($event)">
                <label for="test3">Terminal With Assets<span style="margin-left:5px;color:#00b0ff"><i class="fa fa-info" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="This option does not copy post-sync actions."></i></span></label>
              </p>
              <p *ngIf="level === 2 ">
                <input type="radio" id="test4" name="radio-group" value="terminalPostSynchro" (click)="select($event)">
                <label for="test4">Terminal With Post-Synchro Features <span style="margin-left:5px;color:#00b0ff"><i class="fa fa-info" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="This option does not include assets."></i></span></label>
              </p>
            </form>
          </div>
          <div class="modal-footer">
            <div *ngIf="level === 2 " style="margin-right:50px;"><span style="margin-right: 10px;"><i style="color:#dab13f" class="fas fa-exclamation-triangle"></i></span><span>Any previously imported terminal will be overridden</span></div>
            <div *ngIf="level === 3 " style="margin-right:50px;"><span style="margin-right: 10px;"><i style="color:#dab13f" class="fas fa-exclamation-triangle"></i></span><span>If the imported file(s) exist, they will be overridden.</span></div>
            <button (click)="toggle($event)" type="button" class="btn btn-primary" value="OK">Ok</button>
          </div>
            </div>
        </div>
      </div>
    </div>

  `,
  styles:[`
    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
      position: absolute;
      left: -9999px;
    }
    [type="radio"]:checked + label,
    [type="radio"]:not(:checked) + label
    {
      position: relative;
      padding-left: 28px;
      cursor: pointer;
      line-height: 20px;
      display: inline-block;
      color: #666;
    }
    [type="radio"]:checked + label:before,
    [type="radio"]:not(:checked) + label:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 18px;
      height: 18px;
      border: 1px solid #ddd;
      border-radius: 100%;
      background: #fff;
    }
    [type="radio"]:checked + label:after,
    [type="radio"]:not(:checked) + label:after {
      content: '';
      width: 12px;
      height: 12px;
      background: #F87DA9;
      position: absolute;
      top: 4px;
      left: 4px;
      border-radius: 100%;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }
    [type="radio"]:not(:checked) + label:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    [type="radio"]:checked + label:after {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
    }
    .modal-header{
        background-color:dodgerblue;
        color:antiquewhite;
    }
    .closeX{color:azure;size:25px;}
    .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
    .btn-danger:hover{background-color: #FF2400;}
    .btn.confirm {
      color: #fff;
      background: linear-gradient(to bottom, #6cb3fa, #067dff);
      border-width: 0;
      border-radius: 3px;
    }
    .btn.confirm:active {
      background: #067dff;
    }
      .cloneWindow{height:30px;}

      /* new css*/

    .modal-title{margin-top: -5px;}
    .closeBtnH4{margin-top:-5px;margin-right: -8px;}
    .appWindow {
        height: 35px;
    }
    .clientRow{background-color: #D0DFFE;}

    .led{width:22px;}

    .tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
    th{color:#ffffff;text-align: center;}

    .modalBodyContainer{
      background-color:  #ECE8E5;
    }

    .modal-footer{background-color: #ECE8E5;border-top: groove;}
    .modal-body {
        width: 100%;
    }
    .modal-body thead {
        position: sticky;
        top:0;
    }
    ::-webkit-scrollbar {
        width: 14px;
        height: 5px;
        background-color: #F5F3F0;
    }
    ::-webkit-scrollbar-thumb {
        height: 6px;
        border: 4px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-border-radius: 7px;
        background-color:#BACEFF;
        -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }
    ::-webkit-scrollbar-button {
        width: 14px;
        height: 14px;
        display: none;
    }
    ::-webkit-scrollbar-corner {
        background-color: transparent;
    }

    .modal-dialog {
        margin: 50px auto auto;
        background-color: #0064FE;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .modal-header {
        height:56px;
        background-image: url("../../assets/images/headerBack.jpg");
        color: antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .modal-content {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        padding-left: 3px;
        padding-right: 3px;
        background-color: #0064FE;
        padding-bottom: 3px;
    }

    .closeX {
        color: white;
        size: 25px;
    }

    .btn-outline-danger {
        background-color: #d6462e;
        border-style: solid;
        border-color: white;
        border-width: 2px;
        padding: 0;
    }

    /* .btn-outline-danger:hover {
         width: 32px;
         background-image: url("../../../assets/images/closeBtnHovered.png");
     }*/

    .closeIcon:hover{ width: 32px;background-image: url("../../../assets/images/closeBtnHovered.png");}

    .closeIcon{ width: 32px;background-image: url("../../../assets/images/closeBtn.png");}
    `]
})

export class ImportDuplicateModalComponent implements OnInit {

    private hide = true;

    private level:ProjectLevel;

    private selectedImportOption = ImportOption.Only;

    private selectedCopyOption = DuplicateOptionEnum.configOnly;

    @Input()  forCopyIntention = false;

    @Output() importOptions:EventEmitter<ImportOption> = new EventEmitter();

    @Output() duplicateOption:EventEmitter<DuplicateOptionEnum> = new EventEmitter();

    constructor() {

    }

    ngOnInit(): void {
    }

    public toggle(event?:any) {
      this.hide = !this.hide;
      if(this.forCopyIntention && event!= null && event.target.value === 'OK') {
        this.duplicateOption.emit(this.selectedCopyOption);
      } else if(!this.forCopyIntention && event!= null && event.target.value === 'OK') {
        this.importOptions.emit(this.selectedImportOption);
      }
    }

    public setProjectLevel(level:ProjectLevel) {
      this.level = level;
    }


    private getCorrespondingHierarchy():string {
      return ProjectLevel[this.level];
    }

  select(event:any) {
    switch(event.target.value) {
      case 'full': this.selectedImportOption = ImportOption.Full; break;
      case 'only':this.selectedImportOption = ImportOption.Only;break;
      case 'terminalAssets':this.selectedImportOption = ImportOption.TerminalAndAssets;break;
      case 'terminalPostSynchro':this.selectedImportOption = ImportOption.TerminalAndPostSynchro;break;
      case 'configOnly':this.selectedCopyOption = DuplicateOptionEnum.configOnly;break;
      case 'fullCopy': this.selectedCopyOption = DuplicateOptionEnum.fullCopy;break;
    }
  }
}
